import { LiveAnnouncer } from '@angular/cdk/a11y'
import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core'
import { MatSort, Sort, MatSortModule } from '@angular/material/sort'
import { MatTableDataSource, MatTableModule } from '@angular/material/table'
import { MatIconModule } from '@angular/material/icon'
import { MatButtonModule } from '@angular/material/button'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator'
import { SorteoService } from './services/sorteo.service'
import { CommonModule } from '@angular/common'
import JSConfetti from 'js-confetti'
import { Participante, Winner } from '../../core/models/sorteo.model'
import { MatDividerModule } from '@angular/material/divider'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatSelectModule } from '@angular/material/select'
import { DomSanitizer } from '@angular/platform-browser'

let jsConfetti: any
if (typeof window != 'undefined' && typeof document != 'undefined') {
  jsConfetti = new JSConfetti()
}

const PARTICIPANTES_DATA = [
  {
  user:"@elmolineropeque",
  message:"Gracias al @Atleti conocí a mi mujer un verano de 1994 en el fondo sur de nuestro Calderón, en el 96 nos casamos y aquí seguimos. Ambos son los amores de mi vida. Ni la muerte nos va a separar",
  imgUrl: "https://pbs.twimg.com/profile_images/1008329965803331584/DdmQqqJB_bigger.jpg",
  platform: "X"
  },
  {
  user:"@Setra91",
  message:"Ser del Atleti es irte a cualquier sitio que haya alguien del Atleti y hablar con él como si fuerais amigos de toda la vida, es cruzarte con alguien del Atleti y sentir complicidad sin necesidad de hablar, porque es como la vida, dura pero se disfrutan los buenos momentos",
  imgUrl: "https://pbs.twimg.com/profile_images/1419946710986539069/kkaYB5p__bigger.jpg",
  platform: "X"
  },
  {
  user:"@atm_rojib",
  message:"Hubo un día que me crucé con un sabio, Luis Aragonés se llamaba. Me hizo entender que en la vida hay que darlo todo y defender al máximo tus valores. Me hizo aprender que a veces no es suficiente con darlo todo para ganar, pero sí es suficiente para estar orgulloso ❤️🤍",
  imgUrl: "https://pbs.twimg.com/profile_images/1897010232787628032/R-u2kyF1_bigger.jpg",
  platform: "X"
  },
  {
  user:"@mdc_1011",
  message:"Yo no soy de un equipo, yo nazco de un equipo. El Atlético de Madrid es una familia, no un club.",
  imgUrl: "https://pbs.twimg.com/profile_images/1901429865141907456/XLlAmMmD_bigger.jpg",
  platform: "X"
  },
  {
  user:"@NachoKun9",
  message:"Porque soy una persona que vive tanto lo bueno como lo malo al máximo, porque nunca me han regalado nada y lo que he ido consiguiendo ha sido esfuerzo propio, porque si algo me enseñaron es a tener lealtad y defender a los míos y porque de sus colores me enamoré desde niño.",
  imgUrl:"https://pbs.twimg.com/profile_images/1823311941613375488/cFGO8teH_bigger.jpg",
  platform: "X"
  },
  {
  user:"@rororiqeldismo",
  message:"Nacimos del atleti por qué no hay nada que refleje realmente lo que es la vida en sí que ser del atleti , te caes y te levantas y te vuelves a caer , pero siempre nos levantamos , y creemos en que todo es posible cuando está perdido , qué bonito es ser del atleti , sentimiento",
  imgUrl:"https://pbs.twimg.com/profile_images/1864337404930170881/XTDFoD06_bigger.jpg",
  platform: "X"
  },
  {
  user:"@ChiquitinasMar",
  message:"Porque cuando naci me tuvieron que hacer un cambio de sangre por tener la bilirubina muy alta, y la sangre de la transfusion era Atleti Positivo.",
  imgUrl:"https://pbs.twimg.com/profile_images/1514850203295268873/v9_Agcaz_bigger.jpg",
  platform: "X"
  },
  {
  user:"@Alvarocuevas14",
  message:"La verdad, mi padre es un ciervo de época. Según la hemeroteca llegué un día a casa y dije : 'yo quiero ser del atleti que me gusta más'. Me llevaron al Bernabeú, me vistieron de vikingo... Solo estoy seguro de dos cosas en mi vida: que soy del Atleti y que soy antimadridista.",
  imgUrl:"https://pbs.twimg.com/profile_images/1600453271386312704/hTnZcKqd_bigger.jpg",
  platform: "X"
  },
  {
  user:"@nachodonado",
  message:"Porque Edu me dijo un día que me hiciera del Madrid. Y ya sabéis, hay que hacer lo contrario 😜",
  imgUrl:"/assets/participantes/donado.jpg",
  platform: "Insta"
  },
  {
  user:"@territorio_rojiblanco",
  message:"Según mi abuelo cuando nací, le dijo a mis padres “hacedlo del madrid o del Barcelona para que haya alguno en la familia que no sufra” y mi padre le contesto, “está claro que preferimos que no sufra, pero sin el Atleti, que sentido tendría?”Bendita locura, Aupa Atleti!❤️🤍",
  imgUrl:"/assets/participantes/territorio.jpg",
  platform: "Insta"
  },
  {
  user:"@cristinatg13",
  message:"Mi primera palabra fue Ateti, osea que ser del Atleti me viene de nacimiento. Es fácil, nací siendo del Atleti y cuando tuve más conciencia continué siendo del Atleti por los valores que implica, que son todos los que me representan",
  imgUrl:"/assets/participantes/cris.jpg",
  platform: "Insta"
  },
  {
  user:"@jorgelopezz96",
  message:"Soy del Atleti porque el destino caprichosamente lo quiso. Soy de Albacete, y el 25 de mayo de 1996 se reunió mi familia en mi casa para ver el Atleti - Albacete que nos dio el doblete. Al terminar el partido, mi madre rompió aguas y la llevaron hacia el hospital. Dos días más tarde, el 27 de mayo a las 7 de la mañana, nací literalmente con una bufanda del Atleti bajo el brazo.",
  imgUrl:"/assets/participantes/jorge.jpg",
  platform: "Insta"
  },
  {
  user:"@juanmasoler_",
  message:"desde que soy pequeño mi padre y mi tío me intentaron inculcar los valores madridistas, esos de ganar siempre y tener todo resuelto pero ahí llegó mi abuelo. el me enseñó lo que era luchar, lo que era dejarse la piel, lo que era nunca dejar de creer o el coraje y corazón y solo con ver las rayas rojiblancas algo conectó conmigo, no sé si fueron los colores o fue el sentimiento que ya se adentraba en mi. En 2021 mi abuelo murió, pero murió viendo a su Atleti campeón de liga, en la cama del hospital le pregunté porque éramos del Atleti y el solo supo responderme una cosa: porque lo somos, no lo trates de entender.",
  imgUrl:"/assets/participantes/random.jpg",
  platform: "Insta"
  },
  {
  user:"@javi.suareez",
  message:"Soy del Atleti porque somos la rebeldía, los que nunca damos nuestro brazo a torcer, los que vivimos la vida verdaderamente derrochando coraje y corazón, porque soñamos con algún día tener una cubierta metálica de Alcorex y porque somos los que nos tienen que masticar una y otra vez hasta tener que escupirnos (o masticarnos? 😉).",
  imgUrl:"/assets/participantes/david.jpg",
  platform: "Insta"
  },
  {
  user:"@hector.vallejo98",
  message:"Uno de los primeros recuerdos que tengo en mi vida es un cojín del Atlético de Madrid con el que mi padre me dejaba en la cuna, era lo único que llegaba a ver. La definición perfecta del: 'de padres a hijos' ❤️🤍❤️",
  imgUrl:"/assets/participantes/hector.jpg",
  platform: "Insta"
  },
  {
  user:"@olalladellatorre",
  message:"mi padre me puso Olalla por la mujer de torres , antes de nacer ya sabía que iba a seguir su legado , me llevaba a todas las previas y partidos con apenas meses llevándome en brazos y dándome biberon,yo no entendía nada pero más adelante empecé a ser consciente y a sentir esta pasión",
  imgUrl:"/assets/participantes/random.jpg",
  platform: "Insta"
  },
]

@Component({
    selector: 'sorteo',
    templateUrl: 'sorteo.component.html',
    standalone: true,
    imports: [
        CommonModule,
        MatTableModule,
        MatSortModule,
        MatPaginatorModule,
        MatFormFieldModule,
        MatSelectModule,
        MatIconModule,
        MatButtonModule,
        MatDividerModule,
        MatExpansionModule,
        MatProgressSpinnerModule
    ],
    styleUrl: './sorteo.component.css'
})
export class SorteoComponent implements AfterViewInit {
  @ViewChild(MatSort) sort!: MatSort
  @ViewChild(MatPaginator) paginator!: MatPaginator

  displayedColumns:string[]=["platform", "name","part"]
  dataSource: MatTableDataSource<Participante, MatPaginator> = new MatTableDataSource()
  ganador: Winner | undefined = undefined
  suplente: Winner| undefined = undefined
  selected = 'insta'
  info = {title:'',description:'',restrictions:''}
  submitted:boolean=false

  participantes:any[]=PARTICIPANTES_DATA
  
  constructor(
    private _liveAnnouncer: LiveAnnouncer, 
    private sanitizer: DomSanitizer,
    public service:SorteoService
  ) {}

  ngAfterViewInit() {
    this.reloadList()

    this.participantes.forEach(f=>{
      f.imgUrl = this.sanitizer.bypassSecurityTrustUrl(f.imgUrl)
    })
  }

  reloadList(){
    if(this.selected != 'Coolligan')
    this.service.fetchListSorteo(this.selected) //insta, twitch, gofund
    .subscribe(response => {
      let processResponse = response as any
      this.info = processResponse.info
      this.service.list = processResponse.sorteo
      this.dataSource = new MatTableDataSource(processResponse.participantes as Participante[])
      this.dataSource.sort = this.sort
      this.dataSource.paginator = this.paginator
    }) 
  }

  onSelectionChange() {
    this.reloadList()
  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction) this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`)
    else this._liveAnnouncer.announce('Sorting cleared')
  }

  onSubmit(){
    this.submitted=true
    this.service.generateWinner()
    .subscribe(response => {
        const winners = response as Winner[]
        this.ganador = undefined
        this.suplente = undefined
        setTimeout(()=>{
          this.submitted=false
          this.celebrate()
          this.ganador = winners[0]
          this.suplente = winners[1]
        },3000)
    })
    return false
  }

  @ViewChild('topOfPage') topOfPage!: ElementRef
  elegirGanador(p:any){
    if(confirm('¿Elegir ganador?')){
      this.topOfPage.nativeElement.scrollIntoView({ behavior: 'smooth' })
      this.submitted=true
      this.ganador = undefined
      setTimeout(()=>{
        this.submitted=false
        this.celebrate()
        this.ganador = {name:p.user, platform:p.platform}
      },2000)
    }
  }

  getImageUrl(platform: string){
    switch(platform){
      case 'Insta':
        return 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Instagram_icon.png/640px-Instagram_icon.png'
      case 'X':
        return 'https://cdn.worldvectorlogo.com/logos/x-2.svg'
      case 'YT':
        return 'https://upload.wikimedia.org/wikipedia/commons/e/ef/Youtube_logo.png'
      case 'Gofund':
        return 'https://cdn-icons-png.flaticon.com/512/2111/2111427.png'
      case 'Twitch':
        return 'https://upload.wikimedia.org/wikipedia/commons/3/3a/Twitch_mit_Glitch.png'
      default:
        return ''
    }
  }

  celebrate() {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      //console.warn('renderImage called in SSR, skipping')
      return
    }
    jsConfetti.addConfetti({
      confettiColors: [ '#c30913', '#f2f2f2', '#4464ad', '#c30913' ]
    })
  }
}